import { render, staticRenderFns } from "./support.vue?vue&type=template&id=00b8093f&scoped=true"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"
import style0 from "./support.vue?vue&type=style&index=0&id=00b8093f&prod&lang=scss"
import style1 from "./support.vue?vue&type=style&index=1&id=00b8093f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8093f",
  null
  
)

export default component.exports